<div class="tabs">
  <div class="menu-container">
    <ul
      class="tab-list"
      [ngClass]="{
        visible: isSidebarVisible,
        'tab-layout-on-mobile': !showAsTabOnMobile,
        'left-aligned': showGridOnLeft,
      }"
    >
      @for (tab of tabs; track tab.label) {
        <li
          [class.active]="
            isActive(tab.route && tab.route.trim() ? tab.route : tab.label)
          "
          [class.equal-width-tabs]="equalWidthTabs"
          (keydown)="onTabClick(tab.route, tab.label)"
          (click)="onTabClick(tab.route, tab.label)"
        >
          {{ tab.label }}
          <p-badge *ngIf="tab.count" class="count-badge" [value]="tab.count" />
        </li>
      }
    </ul>
  </div>

  @if (!showAsTabOnMobile) {
    <div class="mobile-ui" [ngClass]="{ 'left-aligned': showGridOnLeft }">
      @if (showGridOnLeft) {
        <span
          class="grid-icon left"
          [innerHTML]="gridIcon | safeHtml"
          (click)="toggleSidebar()"
        ></span>
      }
      <div class="menu-header">
        <h5 [class.hide-on-mobile]="!showTitleOnMobile">{{ activeTab }}</h5>
      </div>
      @if (!showGridOnLeft) {
        <span
          class="grid-icon"
          [innerHTML]="gridIcon | safeHtml"
          (click)="toggleSidebar()"
        ></span>
      }
    </div>
  }
</div>
